import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  aboutMain,
  AboutThree,
  BRC,
  coldstorage,
  coldstore,
  EIC,
  FFSC,
  FSSAI,
  HACCP,
  HomeContactBG,
  MPEDA,
  Quality1,
  Quality16,
  Quality17,
  Quality18,
  Quality2,
  Quality22,
  Quality25,
  Quality28,
  Quality3,
  Quality4,
  Quality5,
  Quality6,
  VideoBG,
} from "../Images";
import Director1 from "../Images/directors/debashish-sen.jpeg";
import Director2 from "../Images/directors/kajari-sen.jpeg";
import Director3 from "../Images/directors/abhijit-chakraborty.jpeg";
import Director4 from "../Images/directors/niladri-saha.jpeg";
import {
  MPEDA_Processing_Plant,
  HACCP_Certificate,
  FSSC_Certificate,
  FSSAI_Shankarpur,
  EIC_CERTIFICATES,
  BRC_Certificate,
} from "../Components/PdfDocument";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import { ContactUsFooter } from "../Layouts";

const AboutUs = () => {
  const [counterUp, setCounterUp] = useState(false);
  const [showDirectorshipModal, setShowDirectorshipModal] = useState(false);

  const certificates = [
    {
      id: 1,
      link: BRC_Certificate,
      image: BRC,
      title: "BRC Certificate",
    },
    {
      id: 2,
      link: EIC_CERTIFICATES,
      image: EIC,
      title: "EIC Certificate",
    },
    {
      id: 3,
      link: FSSAI_Shankarpur,
      image: FSSAI,
      title: "FSSAI",
    },
    {
      id: 4,
      link: FSSC_Certificate,
      image: FFSC,
      title: "FSSC Certificate",
    },
    {
      id: 5,
      link: HACCP_Certificate,
      image: HACCP,
      title: "HACCP Certificate",
    },
    {
      id: 6,
      link: MPEDA_Processing_Plant,
      image: MPEDA,
      title: "MPEDA Processing Plant",
    },
  ];
  const directors = [
    {
      id: 1,
      name: "Mr. Debashish Sen",
      designation: "Managing Director & Promoter",
      image: Director1,
      bio: "Education: Bachelor of Arts (Honours) from University of Calcutta. Experience: 23+ years in procurement, processing, and export of marine fish and aquaculture products. Role: Responsible for manufacturing operations and overall management. Associated since incorporation.",
    },
    {
      id: 2,
      name: "Mrs. Kajari Sen",
      designation: "Non-Executive Director & Promoter",
      image: Director2,
      bio: "Education: Bachelor of Arts from University of Burdwan; appeared for Master's in History (University of Burdwan). Experience: 11+ years in the Seafood Industry. Role: Non-Executive Non-Independent Director. Associated since incorporation.",
    },
    {
      id: 3,
      name: "Mr. Abhijit Chakraborty",
      designation: "Independent Director",
      image: Director3,
      bio: "Education: Bachelor of Science (University of Calcutta) and Bachelor of Law (University of Burdwan). Experience: 17+ years as an Advocate at Calcutta High Court (Civil, Corporate Law, and Litigation). Role: Independent Director since February 6, 2025.",
    },
    {
      id: 4,
      name: "Mr. Niladri Saha",
      designation: "Independent Director",
      image: Director4,
      bio: "Education: Bachelor of Commerce (University of Calcutta). Experience: 10+ years in Finance and Loan Syndication (previously with Axis Bank, Shriram Housing Finance, IndusInd, and Yes Bank). Role: Independent Director since February 6, 2025.",
    },
  ];
  return (
    <>
      <div
        className="site-breadcrumb"
        style={{ backgroundImage: `url(${VideoBG})` }}
      >
        <div className="container">
          <h2 className="breadcrumb-title">About Us</h2>
          <ul className="breadcrumb-menu">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>/</li>
            <li className="active">About Us</li>
          </ul>
        </div>
      </div>

      <div className="about-area py-120 mb-40">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-left">
                <div className="about-img">
                  <img className="about-img-1" src={AboutThree} alt="" />
                  <img className="about-img-2" src={aboutMain} alt="" />
                </div>
                <div className="about-experience">
                  <span>25</span>
                  <h5>
                    Years Of <br /> Experience
                  </h5>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-right">
                <div className="site-heading mb-3">
                  <span className="site-title-tagline">About Us</span>
                  <h2 className="site-title">
                    Explore Your <span>Exciting Fishing</span> World With Us.
                  </h2>
                </div>
                {[
                  `Essex Marine Ltd, Midnapur, India is a modern seafood
                  processing and exporting company, promoted by Sri. Debashish
                  Sen, the Managing Director. The Registered office of the
                  company is at 19, Pollock Street, Kolkata 700 001, WB. The
                  objective of the company is to procure, process, store and
                  export their safe and quality fish and aquaculture products to
                  all the countries including European Union. The company is
                  designed with all modern facilities in line with
                  specifications of national and importing countries.`,
                  `  The Company is installed with the state-of-the-art machineries
                  and equipments.`,
                  ` The company is constructed in an ideal unpolluted location
                  having an advantages of availability of drinking water,
                  skilled manpower, required electricity, uninterrupted
                  communication system, near by port connected with wide NH-
                  highways, abundance of wholesome raw materials and other
                  in-puts.`,
                ].map((item) => (
                  <p className="about-text text-justify">{item}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="destination-area pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 mx-auto">
              <div className="site-heading text-center">
                <span className="site-title-tagline">Leadership</span>
                <h2 className="site-title">
                  Our <span>Management</span>
                </h2>
                <div className="heading-divider"></div>
              </div>
            </div>
          </div>
          <div className="row g-4">
            {directors.map((director) => (
              <div className="col-md-6 col-lg-6" key={director.id}>
                <div className="team-item h-100 p-3">
                  <div
                    className="destination-img"
                    style={{
                      background: "#f8f9fa",
                      width: "100%",
                      height: "300px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={director.image}
                      alt={director.name}
                      style={{
                        width: "100%",
                        height: "300px",
                        objectFit: "contain",
                        backgroundColor: "#f8f9fa",
                        display: "block",
                      }}
                      onError={(e) => {
                        e.currentTarget.style.display = "none";
                      }}
                    />
                  </div>
                  <div className="team-content">
                    <div className="team-bio">
                      <h4 style={{ marginBottom: 8 }}>{director.name}</h4>
                      <h6 style={{ color: "#0056b3", fontWeight: 700 }}>
                        {director.designation}
                      </h6>
                      <p
                        className="about-text text-justify"
                        style={{ fontSize: 17, lineHeight: 1.8 }}
                      >
                        {director.bio}
                      </p>
                      <button
                        type="button"
                        className="theme-btn"
                        onClick={() => setShowDirectorshipModal(true)}
                      >
                        Directorship and full-time positions
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {showDirectorshipModal ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.7)",
            zIndex: 2000,
            padding: "20px",
          }}
          onClick={() => setShowDirectorshipModal(false)}
        >
          <div
            style={{
              maxWidth: "1100px",
              height: "90vh",
              margin: "0 auto",
              background: "#fff",
              borderRadius: "8px",
              overflow: "hidden",
            }}
            onClick={(event) => event.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px 16px",
                borderBottom: "1px solid #eee",
              }}
            >
              <h5 style={{ margin: 0 }}>Directorship and full-time positions</h5>
              <button
                type="button"
                className="theme-btn"
                onClick={() => setShowDirectorshipModal(false)}
              >
                Close
              </button>
            </div>
            <iframe
              title="Directorship and full-time positions"
              src={`${process.env.PUBLIC_URL}/Pdf/Directorship-Positions.pdf`}
              width="100%"
              height="100%"
              style={{ border: 0 }}
            />
          </div>
        </div>
      ) : null}
      <div className="destination-area py-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 mx-auto">
              <div
                className="site-heading text-center wow fadeInDown"
                data-wow-delay=".25s"
              >
                {/* <span className="site-title-tagline">Destination</span> */}
                <h2 className="site-title">
                  Our <span>Cold Store with Modern</span> Racking System
                </h2>
                <div className="heading-divider"></div>
              </div>
            </div>
          </div>
          <div className="row g-4">
            {[Quality22, Quality28, Quality25, Quality22, Quality25].map(
              (item, i) => {
                const customClass = [1, 2].includes(i)
                  ? "col-md-6 col-lg-3"
                  : "col-md-12 col-lg-6";
                return (
                  <>
                    <div className={customClass} key={i}>
                      <Link
                        className="destination-item wow fadeInUp"
                        data-wow-delay=".25s"
                      >
                        <div className="destination-img">
                          <img src={item} alt="" />
                        </div>
                      </Link>
                    </div>
                  </>
                );
              }
            )}
          </div>
          <div className=" mt-5">
            <div
              className="site-heading text-center wow fadeInDown"
              data-wow-delay=".25s"
            >
              <h2 className="site-title" style={{ fontSize: 30 }}>
                We also have a state-of-the-art
                <span> Cold Storage</span> facility in the heart of Kolkata
                within the <span>Udayan Industrial</span> Estate.
              </h2>
              <div
                className="site-heading text-center wow fadeInDown"
                data-wow-delay=".25s"
                style={{
                  visibility: "visible",
                  animationDelay: "0.25s",
                  animationName: "fadeInDown",
                }}
              ></div>
              <span className="site-title-tagline">Under the Brand Of</span>
              <h2 className="site-title">
                <img
                  decoding="async"
                  sizes="(max-width: 480px) 150px"
                  src={coldstore}
                  alt="Logo"
                  className="uag-image-1358"
                  width="300"
                  height="122"
                  title="logo200"
                  loading="lazy"
                  style={{ marginLeft: -25 }}
                />
              </h2>
            </div>
            <p className="about-text text-justify">
              This facility, comprising multiple cold room chambers, serves both
              our domestic sales and external clints with frozen product
              storage. Due to its prime location, our cold storage facility
              consistently operates at full capacity. The entire operations are
              managed by a team of dedicated, experienced, and trained work
              force the able guidance of supervisors, divisional heads and
              General Manager
            </p>
          </div>
        </div>
      </div>
      <div
        className="site-heading text-center wow fadeInDown"
        data-wow-delay=".25s"
        style={{
          visibility: "visible",
          animationDelay: "0.25s",
          animationName: "fadeInDown",
        }}
      >
        <h2 className="site-title">
          We have one of the highest <b />
          <span>production capacity in India</span>
        </h2>
        <div className="heading-divider"></div>
      </div>
      <div className="counter-area bg2 pt-70 pb-70">
        <ScrollTrigger
          onEnter={() => setCounterUp(true)}
          onExit={() => setCounterUp(false)}
        >
          <div className="row g-4 justify-content-center">
            <div className="col-md-12 col-lg-6 col-xl-4">
              <div className="counter-box">
                <div className="icon">
                  <i className="fa-solid fa-shrimp"></i>
                </div>
                <div>
                  <span
                    className="counter"
                    data-count="+"
                    data-to="120"
                    data-speed="3000"
                  >
                    {counterUp && (
                      <CountUp
                        scrollSpyOnce
                        start={0}
                        duration={2}
                        end={17155}
                      />
                    )}{" "}
                    <span
                      style={{
                        fontSize: 28,
                      }}
                    >
                      MT./ Annum
                    </span>
                  </span>
                  <h6 className="title">For Shrimp </h6>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-6 col-xl-4">
              <div className="counter-box">
                <div className="icon">
                  <i className="fa-solid fa-fish"></i>
                </div>
                <div>
                  <span
                    className="counter"
                    data-count="+"
                    data-to="50"
                    data-speed="3000"
                  >
                    {counterUp && (
                      <CountUp
                        scrollSpyOnce
                        start={0}
                        duration={3}
                        end={12775}
                      />
                    )}{" "}
                    <span
                      style={{
                        fontSize: 28,
                      }}
                    >
                      MT./ Annum
                    </span>
                  </span>
                  <h6 className="title">For Fish</h6>
                </div>
              </div>
            </div>
          </div>
        </ScrollTrigger>
      </div>

      <div className="process-area bg py-80">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="main_sec mb-3">
                <div className="blue_area">
                  <h3>
                    IQF Capacity
                    <br />
                    Per Day
                  </h3>
                </div>
                <div className="white_area">
                  <p className="mb-0">
                    ⁠IQF with Glazer and Hardener : 900 kg/hr with an approved
                    capacity of 14.00 tons/day.
                  </p>
                </div>
              </div>
              <div className="main_sec mb-3">
                <div className="blue_area">
                  <h3>
                    Block Freezing
                    <br /> Capacity Per Day
                  </h3>
                </div>
                <div className="white_area">
                  <p className="mb-0">
                    2 Plate Freezers with each capacity of 1000 kg/batch and 2
                    Plate Freezer with each capacity 600 kg/batch with a total
                    approved capacity of 33 Tons/day.
                  </p>
                </div>
              </div>
              <div className="main_sec mb-3">
                <div className="blue_area">
                  <h3>
                    Blast Freezing
                    <br />
                    Capacity Per Day
                  </h3>
                </div>
                <div className="white_area">
                  <p className="mb-0">
                    2 Blast freezers with a combined approved capacity of 35
                    Tons/day.
                  </p>
                </div>
              </div>
              <div className="main_sec mb-3">
                <div className="blue_area">
                  <h3>
                    Cold
                    <br />
                    Storage Capacity
                  </h3>
                </div>
                <div className="white_area">
                  <p className="mb-0">
                    3 Cold storage chambers with modern racking system having a
                    total storing capacity of 720 Tons.
                  </p>
                </div>
              </div>
              <div className="main_sec mb-3">
                <div className="blue_area">
                  <h3>
                    Modern Water
                    <br />
                    Treatment Plant
                  </h3>
                </div>
                <div className="white_area">
                  <p className="mb-0">
                    Ultra modern water treatment plant is installed with RO and
                    UV systems. Water and ice is obtained with the support of
                    the said WTP. The factory is implemented with GMP, SSOP,
                    HACCP, FSSAI and BRC
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="destination-area py-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 mx-auto">
              <div
                className="site-heading text-center wow fadeInDown"
                data-wow-delay=".25s"
              >
                <span className="site-title-tagline">Destination</span>
                <h2 className="site-title">
                  Quality <span> Control</span>
                </h2>
                <div className="heading-divider"></div>
              </div>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-md-12 col-lg-6">
              <Link
                className="destination-item wow fadeInUp"
                data-wow-delay=".25s"
              >
                <div className="destination-img">
                  <img src={Quality1} alt="" />
                </div>
              </Link>
            </div>
            <div className="col-md-6 col-lg-3">
              <Link
                className="destination-item wow fadeInUp"
                data-wow-delay=".25s"
              >
                <div className="destination-img">
                  <img src={Quality2} alt="" />
                </div>
              </Link>
            </div>
            <div className="col-md-6 col-lg-3">
              <Link
                className="destination-item wow fadeInUp"
                data-wow-delay=".25s"
              >
                <div className="destination-img">
                  <img src={Quality3} alt="" />
                </div>
              </Link>
            </div>
            <div className="col-md-6 col-lg-3">
              <Link
                className="destination-item wow fadeInUp"
                data-wow-delay=".25s"
              >
                <div className="destination-img">
                  <img src={Quality4} alt="" />
                </div>
              </Link>
            </div>
            <div className="col-md-6 col-lg-3">
              <Link
                className="destination-item wow fadeInUp"
                data-wow-delay=".25s"
              >
                <div className="destination-img">
                  <img src={Quality5} alt="" />
                </div>
              </Link>
            </div>
            <div className="col-md-12 col-lg-6">
              <Link
                className="destination-item wow fadeInUp"
                data-wow-delay=".25s"
              >
                <div className="destination-img">
                  <img src={Quality6} alt="" />
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="py-80">
        <div
          className="site-heading text-center wow fadeInDown"
          data-wow-delay=".25s"
          style={{
            visibility: "visible",
            animationDelay: "0.25s",
            animationName: "fadeInDown",
          }}
        >
          {/* <span className="site-title-tagline">Destination</span> */}
          <h2 className="site-title">
            Our <span>Certificates</span>
          </h2>
          <div className="heading-divider"></div>
        </div>
        <div className="container">
          <div className="row">
            {certificates.map((certificate) => (
              <div className="col-md-6 col-lg-4" key={certificate.id}>
                <div className="team-item">
                  <Link to={certificate.link} target="_blank">
                    <img src={certificate.image} alt="thumb" />
                    <div className="team-content">
                      <div className="team-bio">
                        <h5>
                          <a href="team.html">{certificate.title}</a>
                        </h5>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <ContactUsFooter />
    </>
  );
};

export default AboutUs;
